import axios from '@/lib/axios';
import type { ChatSession } from './types';

function unwrapData<T>(response: { data: { data?: T } & T }): T {
  return (response.data?.data ?? response.data) as T;
}

export async function startChatSession(params: {
  anonymous_id: string;
  session_id?: string;
}): Promise<ChatSession> {
  const response = await axios.post('/website-chatbot/sessions/', params);
  return unwrapData<ChatSession>(response);
}

export async function fetchChatSession(
  sessionId: string
): Promise<ChatSession> {
  const response = await axios.get(`/website-chatbot/sessions/${sessionId}/`);
  return unwrapData<ChatSession>(response);
}

export async function postChatMessage(
  sessionId: string,
  body: { text?: string; quick_action_id?: string }
): Promise<{
  session_id: string;
  messages: ChatSession['messages'];
  quick_actions: ChatSession['quick_actions'];
}> {
  const response = await axios.post(
    `/website-chatbot/sessions/${sessionId}/messages/`,
    body
  );
  return unwrapData(response);
}

export async function postChatAction(
  sessionId: string,
  body: { action: string; data?: Record<string, unknown> }
) {
  const response = await axios.post(
    `/website-chatbot/sessions/${sessionId}/actions/`,
    body
  );
  return unwrapData(response);
}

export async function closeChatSession(
  sessionId: string
): Promise<ChatSession> {
  const response = await axios.post(
    `/website-chatbot/sessions/${sessionId}/close/`
  );
  return unwrapData<ChatSession>(response);
}

export async function escalateChatSession(
  sessionId: string,
  body: {
    name: string;
    email: string;
    subject: string;
    question: string;
    honeypot?: string;
  }
) {
  const response = await axios.post(
    `/website-chatbot/sessions/${sessionId}/escalate/`,
    body
  );
  return unwrapData<{ message: string; contact_us_id: string }>(response);
}
